import styles from './info-banner.module.css'

const infoText = `cinch joins the nation in expressing our gratitude for the lifelong commitment made by HM Queen Elizabeth II and sends our condolences to the Royal Family.`

export default () => <p className={styles.text}>{infoText}</p>
